import { Component } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { VideosService } from "./core/services/videos.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  title = "oyo";

  videoOpen: string;
  videoOpenSub: Subscription;

  constructor(private videosService: VideosService) {
    this.videoOpenSub = this.videosService.videoOpenCurrent.subscribe(
      videoOpen => {
        this.videoOpen = videoOpen;
      }
    );
  }

  closeVideo($event: Event): void {
    this.videosService.closeVideo();
  }

  onStopPropagation($event: Event): void {
    console.log('stop!');
    $event.stopPropagation();
  }
}
